import env from "react-dotenv";
import getToken from "../hooks/getToken";
import {
  expiredSession,
  handleRefreshToken,
  isTokenExpired,
  wasJustRefreshed,
} from "../hooks/accountHandler";

const FINAL_API_URL = process.env.REACT_APP_API_URL;

const ApiService = {
  version: {
    async versionControl() {
      try {
        const response = await _fetch("/api/v1/version", "GET");
        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    },
  },
  account: {
    async login(username, password, rememberMe) {
      try {
        const response = await _fetch("/api/v1/accounts/login", "POST", {
          username,
          password,
          rememberMe,
        }, false, false);
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    },
    async register(
      firstName,
      lastName,
      emailAddress,
      department,
      username,
      password,
    ) {
      try {
        const response = await _fetch("/api/v1/accounts/register", "POST", {
          first_name: firstName,
          last_name: lastName,
          email_address: emailAddress,
          department,
          username,
          password,
        });
        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    },

    async changePassword(oldPassword, newPassword) {
      try {
        const response = await _fetch(
          "/api/v1/accounts/change-password",
          "POST",
          {
            oldPassword,
            newPassword,
          },
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    },

    async getUserDetails() {
      try {
        const response = await _fetch("/api/v1/accounts/me", "GET");
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    },
    async updateUserDetails(request) {
      try {
        const response = await _fetch(
          "/api/v1/accounts/me",
          "PUT",
          request,
          true,
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error:", error);
        throw error;
      }
    },
  },
  token: {
    async verifyToken(token) {
      try {
        const response = await _fetch("/api/v1/tokens/verify", "POST", {
          token,
        });

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  conversation: {
    async getAllConversations() {
      try {
        const response = await _fetch("/api/v1/conversations", "GET");

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async getConversationDetail(conversationId) {
      try {
        const response = await _fetch(
          `/api/v1/conversations/${conversationId}`,
          "GET",
        );

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async createConversation(request) {
      try {
        const response = await _fetch(
          `/api/v1/conversations`,
          "POST",
          request,
          true,
        );

        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async updateConversation(request, conversationId) {
      try {
        const response = await _fetch(
          `/api/v1/conversations/${conversationId}`,
          "PATCH",
          request,
        );

        // if (!response.ok) expiredSession();
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async updateConversationDetail(request, conversationId) {
      try {
        const response = await _fetch(
          `/api/v1/conversations/${conversationId}`,
          "PUT",
          request,
          true,
        );

        // if (!response.ok) expiredSession();
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getConversationActionByConversationId(conversationId) {
      try {
        const response = await _fetch(
          `/api/v1/conversations/actions/${conversationId}`,
          "GET",
        );

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  message: {
    async getConversationMessages(
      conversationId,
      before_createdAt = null,
      limit = 30,
    ) {
      try {
        const params = new URLSearchParams({ limit: String(limit) });
        if (before_createdAt) params.set("before_createdAt", before_createdAt);
        const response = await _fetch(
          `/api/v2/messages/${conversationId}?${params.toString()}`,
          "GET",
        );

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async sendMessage(request, conversationId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/${conversationId}`,
          "POST",
          request,
          true,
        );

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async searchMessage(request, conversationId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/search/${conversationId}`,
          "POST",
          request,
        );
        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async deleteMessage(conversationId, messageId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/${conversationId}/${messageId}`,
          "DELETE",
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async getThreadMessages(conversationId, messageId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/thread/${conversationId}/${messageId}`,
          "GET",
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async replyThreadMessage(request, conversationId, messageId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/${conversationId}/${messageId}`,
          "POST",
          request,
          true,
        );

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async getMessagePosition(conversationId, messageId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/${conversationId}/${messageId}`,
          "GET",
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async addRemoveReaction(conversationId, messageId, request) {
      try {
        const response = await _fetch(
          `/api/v1/messages/${conversationId}/${messageId}`,
          "PUT",
          request,
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getUserSpecificReaction() {
      try {
        const response = await _fetch(
          `/api/v1/messages/user/specific/message/reactions`,
          "GET",
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async globalSearchMessage(request) {
      try {
        const response = await _fetch(
          `/api/v1/messages/global/search/`,
          "POST",
          request,
        );
        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async pinMessage(conversationId, messageId) {
      try {
        const response = await _fetch(
          `/api/v1/messages/${conversationId}/${messageId}`,
          "PATCH",
        );
        // if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  users: {
    async getAllusers() {
      try {
        const response = await _fetch(`/api/v1/users`, "GET");

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getAllNotifications() {
      try {
        const response = await _fetch(`/api/v1/users/notifications`, "GET");

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getAllNotificationsv2(page, limit) {
      try {
        const response = await _fetch(
          `/api/v2/users/notifications?page=${page}&limit=${limit}`,
          "GET",
        );

        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  conversationMembers: {
    async updateConversationMember(
      conversation_id,
      conversation_member_id,
      request,
    ) {
      try {
        const response = await _fetch(
          `/api/v1/conversation-member/${conversation_id}/${conversation_member_id}`,
          "PATCH",
          request,
          false,
        );
        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async addConversationMember(conversation_id, request) {
      try {
        const response = await _fetch(
          `/api/v1/conversation-member/${conversation_id}`,
          "PUT",
          request,
          false,
        );
        // if (!response.ok) expiredSession();
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  files: {
    async getAllConversationFiles(conversation_id) {
      try {
        const response = await _fetch(
          `/api/v1/files/${conversation_id}`,
          "GET",
        );
        if (!response.ok) expiredSession();

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getConversationImage(imageFileName) {
      try {
        const response = await _fetch(
          `/assets/message-attachment/${imageFileName}`,
          "GET",
        );

        const result = await response.blob();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  notifications: {
    async readDeleteNotification(request, notification_id) {
      try {
        const response = await _fetch(
          `/api/v1/notifications/${notification_id}`,
          "POST",
          request,
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  forms: {
    async getMyForms() {
      try {
        const response = await _fetch(`/api/v1/forms`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getForms() {
      try {
        const response = await _fetch(`/api/v2/forms`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getFormDetailById(form_id) {
      try {
        const response = await _fetch(`/api/v1/forms/${form_id}`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async submitFormRequest(form_id, request) {
      try {
        const response = await _fetch(
          `/api/v1/forms/${form_id}`,
          "POST",
          request,
          true,
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getMyRequests() {
      try {
        const response = await _fetch(`/api/v1/forms/me/requests`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getMyRequestsV2(page = 1, limit = 12, keyword = "") {
      try {
        const response = await _fetch(
          `/api/v2/forms/me/requests?page=${page}&limit=${limit}&keyword=${keyword}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getReportListV2(
      page = 1,
      limit = 12,
      keyword = "",
      selectedForm = "",
    ) {
      try {
        const response = await _fetch(
          `/api/v2/forms/reports/list?page=${page}&limit=${limit}&keyword=${keyword}&form_id=${selectedForm}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getMyApprovalHistoryV2(page = 1, limit = 12, keyword = "") {
      try {
        const response = await _fetch(
          `/api/v2/forms/me/approvals/history?page=${page}&limit=${limit}&query=${keyword}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getFormRequestDetail(request_type, link_id) {
      try {
        const response = await _fetch(
          `/api/v1/forms/me/requests/${request_type}/${link_id}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getApprovalRequestsList() {
      try {
        const response = await _fetch(`/api/v1/forms/me/approvals`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getApprovalRequestsListV2(
      page = 1,
      limit = 12,
      keyword = "",
      formFilter = "",
    ) {
      try {
        const response = await _fetch(
          `/api/v2/forms/me/approvals?page=${page}&limit=${limit}&keyword=${keyword}&formFilter=${formFilter}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async approveDenyRequest(
  form_id,
  request_id,
  status,
) {
  try {
    // CCAR: FormData submission
    if (form_id instanceof FormData) {
      const response = await _fetch(
        "/api/v1/forms/me/requests",
        "POST",
        form_id,
        true,
      );

      const result = await response.json();

      return result;
    }

    // Existing ePR: JSON submission
    const response = await _fetch(
      "/api/v1/forms/me/requests",
      "POST",
      {
        form_id,
        request_id,
        status,
      },
    );

    const result = await response.json();

    return result;
  } catch (err) {
    console.error(err);
    return err;
  }
},
    async tagRequest(form_id, request_id, status) {
      try {
        const response = await _fetch(`/api/v1/forms/reports/tagging`, "POST", {
          form_id,
          request_id,
          status,
        });

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async cancelRequest(form_id, request_id, status) {
      try {
        const response = await _fetch(`/api/v1/forms/reports/cancel`, "POST", {
          form_id,
          request_id,
          status,
        });

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getPagePermissions() {
      try {
        const response = await _fetch(`/api/v1/forms/me/permissions`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getRequestsHistory(query = "") {
      try {
        const response = await _fetch(
          `/api/v1/forms/me/requests/history?query=${query}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getRequestsHistoryV2(page = 1, limit = 12, query = "") {
      try {
        const response = await _fetch(
          `/api/v2/forms/me/requests/history?page=${page}&limit=${limit}&query=${query}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getForTagging(query = "") {
      try {
        const response = await _fetch(
          `/api/v1/forms/reports/tagging?query=${query}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getForTaggingV2(page = 1, limit = 12, query = "", formFilter = "") {
      try {
        const response = await _fetch(
          `/api/v2/forms/reports/tagging?page=${page}&limit=${limit}&query=${query}&formFilter=${formFilter}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
      async getForCCAR(page = 1, limit = 12, query = "", formFilter = "") {
      try {
        const response = await _fetch(
          `/api/v2/forms/reports/ccar?page=${page}&limit=${limit}&query=${query}&formFilter=${formFilter}`,
          "GET",
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getDashboardReports() {
      try {
        const response = await _fetch(`/api/v1/forms/me/reports`, "GET");

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },

    async submitOffsetRequest(form_id, request) {
      try {
        const response = await _fetch(
          `/api/v1/forms/offset/${form_id}`,
          "POST",
          request,
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async submitProspectingRequest(form_id, request) {
      try {
        const response = await _fetch(
          `/api/v1/forms/prospecting/${form_id}`,
          "POST",
          request,
          true,
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async submitCCARRequest(form_id, request) {
      try {
        const response = await _fetch(
          `/api/v1/forms/ccar/${form_id}`,
          "POST",
          request,
          true,
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);

        return {
          success: false,
          error: err,
        };
      }
    },
    async submitTransmittalRequest(form_id, request) {
      try {
        const response = await _fetch(
          `/api/v1/forms/transmittal/${form_id}`,
          "POST",
          request,
          true,
        );

        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  directMessage: {
    async sendDirectMessage(request) {
      try {
        const response = await _fetch(
          `/api/v1/direct-message`,
          "POST",
          request,
        );
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  talk_to_ai: {
    async talktoAI(request) {
      try {
        const response = await _fetch(`/api/v1/ai/query`, "POST", request);
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    // Streams the answer as Server-Sent Events. onEvent(name, data) is called for
    // conversation, status, delta, reset, done and error events.
    async streamQuery(request, onEvent) {
      const response = await _fetch(`/api/v1/ai/query/stream`, "POST", request);
      const contentType = response.headers.get("content-type") || "";
      if (!response.ok || !contentType.includes("text/event-stream") || !response.body) {
        let message = "Something went wrong. Please try again.";
        try {
          const result = await response.json();
          if (result?.message) message = result.message;
        } catch {}
        onEvent("error", { message });
        return;
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = "";
      for (;;) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        let boundary;
        while ((boundary = buffer.indexOf("\n\n")) !== -1) {
          const chunk = buffer.slice(0, boundary);
          buffer = buffer.slice(boundary + 2);
          let event = "message";
          let data = "";
          chunk.split("\n").forEach((line) => {
            if (line.startsWith("event:")) event = line.slice(6).trim();
            else if (line.startsWith("data:")) data += line.slice(5).trim();
          });
          if (!data) continue;
          try {
            onEvent(event, JSON.parse(data));
          } catch (err) {
            console.error("Bad AI stream event:", err);
          }
        }
      }
    },
    async listConversations(search = "") {
      try {
        const params = new URLSearchParams();
        if (search.trim()) params.set("search", search.trim());
        const qs = params.toString();
        const response = await _fetch(
          `/api/v1/ai/conversations${qs ? `?${qs}` : ""}`,
          "GET",
        );
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async createConversation(request) {
      try {
        const response = await _fetch(
          `/api/v1/ai/conversations`,
          "POST",
          request,
        );
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getConversation(id) {
      try {
        const response = await _fetch(`/api/v1/ai/conversations/${id}`, "GET");
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async updateConversation(id, request) {
      try {
        const response = await _fetch(
          `/api/v1/ai/conversations/${id}`,
          "PATCH",
          request,
        );
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async deleteConversation(id) {
      try {
        const response = await _fetch(
          `/api/v1/ai/conversations/${id}`,
          "DELETE",
        );
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  tasks: {
    async getMyTasks() {
      try {
        const response = await _fetch(`/api/v1/tasks`, "GET");
        const result = await response.json();
        return result;
      } catch (err) {
        console.error("Error:", err);
      }
    },
  },
  v2: {
    conversations: {
      async getConversationUnreadCount() {
        try {
          const response = await _fetch(
            `/api/v2/conversations/unread-count`,
            "GET",
          );

          const result = await response.json();
          return result;
        } catch (err) {
          console.error("Error:", err);
        }
      },
      async getConversationByUserWithFlag(conversation_type = "personal") {
        try {
          const response = await _fetch(
            `/api/v2/conversations?conversation_filter=${conversation_type}`,
            "GET",
          );

          const result = await response.json();
          return result;
        } catch (err) {
          console.error("Error:", err);
        }
      },
      async getConversationDetailById(conversation_id) {
        try {
          const response = await _fetch(
            `/api/v2/conversations/${conversation_id}`,
            "GET",
          );

          if (!response.ok) expiredSession();

          const result = await response.json();
          return result;
        } catch (err) {
          console.error("Error:", err);
        }
      },
    },
    account: {
      async login(username, password, rememberMe) {
        try {
          const response = await _fetch("/api/v2/accounts/login", "POST", {
            username,
            password,
            rememberMe,
          }, false, false);
          // if (!response.ok) expiredSession();

          const result = await response.json();
          return result;
        } catch (error) {
          console.error("Error:", error);
          throw error;
        }
      },
      async refreshToken(refreshToken) {
        try {
          // allowRefresh is false so this request cannot start another refresh.
          const response = await _fetch(
            "/api/v2/accounts/refresh-token",
            "POST",
            {
              refreshToken,
            },
            false,
            false,
            false,
          );
          // if (!response.ok) expiredSession();

          const result = await response.json();
          return result;
        } catch (error) {
          console.error("Error:", error);
          throw error;
        }
      },
    },
    message: {
      async globalSearchMessage(request) {
        try {
          const response = await _fetch(
            `/api/v2/messages/global/search/`,
            "POST",
            request,
          );
          // if (!response.ok) expiredSession();

          const result = await response.json();
          return result;
        } catch (err) {
          console.error("Error:", err);
        }
      },
    },
  },
  v3: {
    conversations: {
      async getConversationByUserWithFlag(
        conversation_type = "personal",
        page = 1,
        limit = 10,
      ) {
        try {
          const response = await _fetch(
            `/api/v3/conversations?conversation_filter=${conversation_type}&page=${page}&limit=${limit}`,
            "GET",
          );

          const result = await response.json();
          return result;
        } catch (err) {
          console.error("Error:", err);
        }
      },
    },
    message: {
      async getMessagesAround(
        conversationId,
        messageId,
        before = 40,
        after = 40,
      ) {
        try {
          const safeBefore = Math.min(Math.max(Number(before) || 0, 0), 100);
          const safeAfter = Math.min(Math.max(Number(after) || 0, 0), 100);
          const params = new URLSearchParams({
            before: String(safeBefore),
            after: String(safeAfter),
          });

          const response = await _fetch(
            `/api/v3/messages/${conversationId}/around/${messageId}?${params.toString()}`,
            "GET",
          );

          const result = await response.json();
          return {
            ...(result || {}),
            httpStatus: response.status,
          };
        } catch (err) {
          console.error("Error:", err);
          throw err;
        }
      },

      async getOlderMessages(
        conversationId,
        beforeCreatedAt,
        beforeId,
        limit = 50,
      ) {
        try {
          const safeLimit = Math.min(Math.max(Number(limit) || 1, 1), 100);
          const params = new URLSearchParams({ limit: String(safeLimit) });

          if (beforeCreatedAt) params.set("before_createdAt", beforeCreatedAt);
          if (beforeId !== undefined && beforeId !== null && beforeId !== "") {
            params.set("before_id", String(beforeId));
          }

          const response = await _fetch(
            `/api/v3/messages/${conversationId}?${params.toString()}`,
            "GET",
          );

          const result = await response.json();
          return {
            ...(result || {}),
            httpStatus: response.status,
          };
        } catch (err) {
          console.error("Error:", err);
          throw err;
        }
      },

      async getNewerMessages(
        conversationId,
        afterCreatedAt,
        afterId,
        limit = 50,
      ) {
        try {
          const safeLimit = Math.min(Math.max(Number(limit) || 1, 1), 100);
          const params = new URLSearchParams({ limit: String(safeLimit) });

          if (afterCreatedAt) params.set("after_createdAt", afterCreatedAt);
          if (afterId !== undefined && afterId !== null && afterId !== "") {
            params.set("after_id", String(afterId));
          }

          const response = await _fetch(
            `/api/v3/messages/${conversationId}?${params.toString()}`,
            "GET",
          );

          const result = await response.json();
          return {
            ...(result || {}),
            httpStatus: response.status,
          };
        } catch (err) {
          console.error("Error:", err);
          throw err;
        }
      },
    },
  },
};

async function _fetch(
  apiUrl,
  reqMethod,
  reqBody,
  isFormData = false,
  retry = true,
  allowRefresh = true,
) {
  let token = getToken("token");
  const refreshToken = getToken("refreshToken");
  let didAttemptRefresh = false;
  let tokenFromRefresh = null;

  if (
    allowRefresh &&
    token &&
    !wasJustRefreshed(token) &&
    isTokenExpired(token) &&
    refreshToken
  ) {
    didAttemptRefresh = true;
    tokenFromRefresh = await handleRefreshToken();
    if (tokenFromRefresh) token = tokenFromRefresh;
  }

  let headers = {
    Authorization: token ? `Bearer ${token}` : "",
  };

  let body;
  if (isFormData) {
    body = reqBody;
  } else {
    headers["Content-Type"] = "application/json";
    body = reqBody ? JSON.stringify(reqBody) : null;
  }

  let response = await fetch(`${FINAL_API_URL}${apiUrl}`, {
    method: reqMethod,
    headers,
    body,
  });

  if (response.status === 401 && retry && allowRefresh) {
    if (!refreshToken) {
      expiredSession();
      return response;
    }

    const newToken = didAttemptRefresh
      ? tokenFromRefresh
      : await handleRefreshToken();

    if (!newToken) {
      expiredSession();
      return response;
    }

    return _fetch(apiUrl, reqMethod, reqBody, isFormData, false, allowRefresh);
  }

  return response;
}

export default ApiService;
